import { forwardRef } from "react";
import {
  TextField,
  TextFieldInput,
  TextFieldLabel,
} from "@hireart/component-library";
import PropTypes from "prop-types";
import ReactPhoneNumberInput from "react-phone-number-input/input";

export const PhoneTextField = forwardRef(
  (
    {
      "aria-describedby": ariaDescribedBy = undefined,
      className = "",
      country = "US",
      hasError = false,
      id,
      isDisabled = false,
      isOptional = false,
      label,
      name = undefined,
      onChange,
      value = "",
    },
    ref
  ) => {
    const handleChange = (newValue) => {
      const isInputEmpty = newValue === undefined;
      const eventValue = isInputEmpty ? "" : newValue;

      onChange({ target: { name, value: eventValue } });
    };

    return (
      <TextField
        className={className}
        hasError={hasError}
        isOptional={isOptional}
        isDisabled={isDisabled}
      >
        <TextFieldLabel htmlFor={id}>{label}</TextFieldLabel>
        <ReactPhoneNumberInput
          ref={ref}
          aria-describedby={ariaDescribedBy}
          autoComplete="tel"
          country={country}
          type="tel"
          id={id}
          inputComponent={TextFieldInput}
          name={name}
          onChange={handleChange}
          value={value}
        />
      </TextField>
    );
  }
);

PhoneTextField.displayName = "PhoneTextField";

PhoneTextField.propTypes = {
  "aria-describedby": PropTypes.string,
  className: PropTypes.string,
  country: PropTypes.string,
  hasError: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  isOptional: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};
